module.exports = __webpack_public_path__ + "assets/img/5_1376_big.e91c7635.jpg";